import Breadcrumb from './Breadcrumb';
export default Breadcrumb;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/breadcrumb/index.js
// module id = 252
// module chunks = 0